import "core-js/modules/es.array.for-each";
import "core-js/modules/es.number.constructor";
import "core-js/modules/web.dom-collections.for-each";
//
//
//
//
//
//
//
import { getDataJson, pollingRefresh } from "@/utils/refreshCptData";
export default {
  name: "cpt-dataV-scrollTable",
  inject: ['queryParam'],
  props: {
    width: Number,
    height: Number,
    option: Object
  },
  data: function data() {
    return {
      config: {},
      uuid: null,
      refreshFlagKey: null
    };
  },
  watch: {
    'option.attribute': {
      handler: function handler() {
        this.loadData();
      },
      deep: true //深度监听

    }
  },
  created: function created() {
    this.uuid = require('uuid').v1();
    this.refreshFlagKey = require('uuid').v1();
    this.refreshCptData();
  },
  methods: {
    refreshCptData: function refreshCptData() {
      pollingRefresh(this.uuid, this.option.cptDataForm, this.loadData);
    },
    loadData: function loadData() {
      var _this = this;

      getDataJson(this.option.cptDataForm, this.queryParam, "ScrollTable").then(function (res) {
        var temp = JSON.parse(JSON.stringify(_this.option.attribute));
        var columns = JSON.parse(temp.columns);
        temp.header = [];
        temp.columnWidth = [80]; //列宽

        temp.data = [];
        temp.align = ['center']; //对齐方式

        columns.forEach(function (item) {
          temp.header.push(item.title);

          if (item.width) {
            temp.columnWidth.push(item.width);
          }

          temp.align.push('center');
        });
        res.forEach(function (item) {
          var row = [];
          columns.forEach(function (column) {
            row.push(item[column.key]);
          });
          temp.data.push(row);
        });
        _this.config = temp;
        _this.refreshFlagKey = require('uuid').v1();
      });
    }
  }
};